import { X_PIXEL_ID } from "constants/xPixelConfig";
import type { TwqFunction } from "types/xPixel";

import "types/xPixel";

let xPixelBootstrapped = false;

/**
 * Bootstraps the X website tag loader and queues the pixel config call.
 */
function bootstrapXPixelLoader(): TwqFunction {
  if (window.twq) {
    return window.twq;
  }

  const twqStub = function (...args: unknown[]) {
    if (twqStub.exe) {
      twqStub.exe(...args);
      return;
    }
    twqStub.queue.push(args);
  } as TwqFunction;

  twqStub.version = "1.1";
  twqStub.queue = [];
  window.twq = twqStub;

  const scriptElement = document.createElement("script");
  scriptElement.async = true;
  scriptElement.src = "https://static.ads-twitter.com/uwt.js";

  const firstScriptElement = document.getElementsByTagName("script")[0];
  if (!firstScriptElement?.parentNode) {
    throw new Error("Unable to bootstrap X pixel: script insertion point not found");
  }

  firstScriptElement.parentNode.insertBefore(scriptElement, firstScriptElement);

  return twqStub;
}

/**
 * Loads the X website tag when marketing cookies are accepted.
 *
 * @param params.marketingGranted - Whether the visitor accepted marketing cookies.
 */
export function loadXPixelIfConsented(params: { marketingGranted: boolean }): void {
  const { marketingGranted } = params;

  if (!marketingGranted || xPixelBootstrapped) {
    return;
  }

  xPixelBootstrapped = true;

  const twq = bootstrapXPixelLoader();
  twq("config", X_PIXEL_ID);
}
